import { UserTaskListStore } from './user-task-list.store';
import { Component, computed, inject, input } from '@angular/core';
import { UserTaskItemComponent } from '../user-task-item/user-task-item.component';
import { FilterBuilder } from '../../../../../modules/content/helper/filter.builder';
import { getUserTaskFrag } from '../user-tasks/user-tasks.query';
import { Operator } from '../../../../../../../../data-grid/src/grid/grid-request.dto';
import { InfiniteScrollStore } from '../../../../../modules/shared/store/common/infinite-scroll.store';
import { UserTaskObject } from '@libs/types/src/services/object-type/user/user-task.object';
import {
    InfiniteScrollLoadOnScreenComponent,
} from '../../../../kit/infinite-scroll/infinite-scroll-load-on-screen/infinite-scroll-load-on-screen.component';
import { EmptyStateComponent } from '../../../../../modules/shared/components/empty-state/empty-state.component';

@Component({
    selector: 'app-user-task-list',
    templateUrl: './user-task-list.component.html',
    styleUrl: './user-task-list.component.scss',
    providers: [UserTaskListStore],
    imports: [
        UserTaskItemComponent,
        InfiniteScrollLoadOnScreenComponent,
        EmptyStateComponent,
    ],
})
export class UserTaskListComponent {

    public readonly store = inject(UserTaskListStore);

    public folderId = input<number | null>(null);
    public completed = input.required<boolean>();

    public tasks = computed(() => {
        const currentUserId = this.store.globalGlobalStore.loggedUserStore.currentUserId();

        if (!currentUserId) return null;

        const filter = new FilterBuilder();
        filter.where('completedAt', this.completed(), this.completed() ? Operator.NEMPTY : Operator.EMPTY);

        if (this.folderId()) {
            filter.where('folderId', this.folderId()?.toString());
        } else {
            filter.where('userId', this.store.globalGlobalStore.loggedUserStore.currentUserId());
        }

        filter.sort('createdAt', 'DESC');

        return new InfiniteScrollStore<UserTaskObject>(
            this.store.api.getUserTasks,
            filter.filter(),
            false,
            getUserTaskFrag,
        );
    });

    constructor() {
        this.store.onSuccess(
            () => this.tasks()?.refresh(),
            'createUserTask',
            'updateUserTask',
            'deleteUserTask',
            'createUserTaskEntry',
        );
    }
}
